import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule, OverlayPanel } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';
import { SkeletonModule } from 'primeng/skeleton';

import {
  NotificacionesInternasService,
  NotificacionInterna,
} from '@core-services/notificaciones-internas.service';

@Component({
  selector: 'app-notification-bell',
  standalone: true,
  imports: [
    CommonModule,
    BadgeModule,
    ButtonModule,
    OverlayPanelModule,
    TooltipModule,
    SkeletonModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss'],
})
export class NotificationBellComponent implements OnInit, OnDestroy {
  @ViewChild('op') op!: OverlayPanel;

  items: NotificacionInterna[] = [];
  count = 0;
  loading = false;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly svc: NotificacionesInternasService,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.svc.count$.pipe(takeUntil(this.destroy$)).subscribe((c) => {
      this.count = c;
      this.cdr.markForCheck();
    });

    this.svc.nueva$.pipe(takeUntil(this.destroy$)).subscribe((n) => {
      this.items.unshift(n);
      if (this.items.length > 20) this.items.pop();
      this.cdr.markForCheck();
    });

    this.svc.iniciarEscucha();
    this.svc.refrescarConteo();
  }

  toggle(event: Event): void {
    this.op.toggle(event);
    if (!this.op.overlayVisible) {
      this.cargarLista();
    }
  }

  onShow(): void {
    this.cargarLista();
  }

  marcarLeida(item: NotificacionInterna): void {
    if (item.leida) return;
    this.svc.marcarLeida(item.id).subscribe(() => {
      item.leida = true;
      this.cdr.markForCheck();
    });
  }

  marcarTodasLeidas(): void {
    this.svc.marcarTodasLeidas().subscribe(() => {
      this.items.forEach((i) => (i.leida = true));
      this.cdr.markForCheck();
    });
  }

  eliminar(item: NotificacionInterna, event: Event): void {
    event.stopPropagation();
    this.svc.eliminar(item.id).subscribe(() => {
      this.items = this.items.filter((i) => i.id !== item.id);
      if (!item.leida) this.svc.refrescarConteo();
      this.cdr.markForCheck();
    });
  }

  navegar(item: NotificacionInterna): void {
    if (!item.enlace) return;
    this.marcarLeida(item);
    this.op.hide();
    this.router.navigateByUrl(item.enlace);
  }

  verTodas(): void {
    this.op.hide();
    this.router.navigateByUrl('/sistema/notificaciones/historial');
  }

  trackById(_: number, item: NotificacionInterna): number {
    return item.id;
  }

  private cargarLista(): void {
    this.loading = true;
    this.cdr.markForCheck();
    this.svc.listar(20, 0).subscribe({
      next: (items) => {
        this.items = items;
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.cdr.markForCheck();
      },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
